module.exports = __webpack_public_path__ + "static/warranty-4fb619fb8392c038872913c6638fb137.png";